module.exports = __webpack_public_path__ + "static/heroOlympo29-69703e56019c49b9ad9e41c1c1521c1b.png";